import { makeStyles } from "@material-ui/core/styles";

import ErrorIcon from "Assets/images/exclamation-mark.svg";

const useStyles = makeStyles((theme) => {
  return {
    pointerNone: {
      pointerEvents: "none",
    },
    stepperMenu: {
      position: "fixed",
      top: 180,
      left: "2%",
      "@media(max-width: 1279px)": {
        left: "2%",
        background: "#f0f2f6",
        paddingTop: 10,
      },
      "@media(max-width: 1024px)": {
        left: "3%",
      },
      "@media(max-width: 1023px)": {
        flexDirection: "row !important",
        top: 119,
        position: "sticky",
        zIndex: 2,
        width: "100%",
        display: "flex !important",
        justifyContent: "center",
      },
      "@media(min-width: 1280px)": {
        top: 200,
        left: "3%",
      },
      "@media(min-width: 1536px)": {
        top: 200,
        left: "5%",
      },
      "@media(min-width: 1600px)": {
        left: "4%",
      },
      "@media(min-width:1920px)": {
        top: 250,
        left: "11%",
      },
      [theme.breakpoints.down("xs")]: {
        top: 110,
        overflow: "auto",
      },
      "& .MuiStep-root": {
        height: 60,
        position: "relative",
        "&:before": {
          width: 2,
          height: "100%",
          background: "#DBDEEA",
          content: '""',
          position: "absolute",
          top: 5,
          left: 7,
          zIndex: -1,
          "@media(max-width: 1023px)": {
            display: "none",
          },
        },
        "&:last-child": {
          "&:before": {
            content: "none",
          },
        },
        "@media(max-width: 1200px)": {
          height: 40,
        },
      },
      "& .MuiStepLabel-root": {
        padding: 0,
        alignItems: "flex-start",
        cursor: "pointer",
      },
      "& .MuiStepLabel-iconContainer": {
        background: "#fff",
        width: 18,
        height: 18,
        borderRadius: "50%",
        marginRight: 14,
        position: "absolute",
      },
      "& .MuiSvgIcon-root": {
        display: "none",
      },
      "& .MuiStepLabel-label": {
        color: "#0D2436",
        fontSize: 14,
        fontFamily: "inherit",
        width: 130,
        cursor: "pointer",
        marginLeft: 26,
        "@media(min-width: 1450px)": {
          width: 110,
        },
        "@media(min-width: 1600px)": {
          width: 190,
        },
        "@media(max-width: 1279px)": {
          display: "none",
        },
      },
      "& .MuiStepConnector-root": {
        display: "none",
        "@media(max-width: 1023px)": {
          margin: "8px 0 0 16px",
          flex: "unset",
          display: "block",
          "& .MuiStepConnector-line": {
            width: 15,
            borderTop: "solid 1px #bdbdbd",
            borderLeft: "none",
            margin: "0 8px 0 8px",
          },
        },
      },
      "& .activeScrollSpy": {
        "& .MuiStepLabel-iconContainer": {
          width: 18,
          height: 18,
          boxShadow: "0px 0px 6px #9EB6CFB3",
          background: theme.palette.secondary.main,
          "&:before": {
            background: "#fff",
            width: 24,
            height: 24,
            content: '""',
            position: "absolute",
            borderRadius: "50%",
            left: -4,
            top: -4,
            zIndex: -1,
            boxShadow: "0px 0px 6px #9eb6cfb3",
          },
        },
        "& .MuiStepLabel-label": {
          fontWeight: 600,
        },
      },
      "& .Mui-error": {
        color: "#F84E4E !important",
        "& .MuiStepLabel-iconContainer": {
          background: "#F84E4E !important",
          border: "1px solid #fff",
          "&:after": {
            background: `url(${ErrorIcon}) no-repeat`,
            content: '""',
            position: "absolute",
            width: 10,
            height: 10,
            backgroundSize: "contain",
            filter: "invert(100%)",
            left: 3,
            top: 3,
          },
        },
        "& .MuiStepLabel-labelContainer": {
          // paddingLeft:20,
          "& .MuiTypography-root": {
            marginLeft: 26,
            color: "#F84E4E",
          },
        },
      },
    },
    activeStep: {
      width: 16,
      height: 16,
      minWidth: 16,
      borderRadius: "50%",
      boxShadow: "0px 0px 6px #9EB6CFB3",
      background: theme.palette.secondary.main,
      "&:before": {
        background: "#fff",
        width: 24,
        height: 24,
        content: '""',
        position: "absolute",
        borderRadius: "50%",
        left: -4,
        top: -4,
        zIndex: -1,
        boxShadow: "0px 0px 6px #9eb6cfb3",
      },
    },
  };
});

export default useStyles;
